import DatasetAddRemoteView from "admin/dataset/dataset_add_remote_view";
import { getDatastores } from "admin/rest_api";
import { useFetch } from "libs/react_helpers";
import { getUrlParamsObject } from "libs/utils";
import has from "lodash-es/has";
import { useNavigate } from "react-router-dom";

export function DatasetURLImport() {
  const navigate = useNavigate();
  const datastores = useFetch(async () => await getDatastores(), null, []);
  const params = getUrlParamsObject();
  const datasetUri = has(params, "url") ? params.url : null;
  const handleDatasetAdded = async (addedDatasetId: string): Promise<void> => {
    navigate(`/datasets/${addedDatasetId}/view`);
  };

  return datastores != null ? (
    <DatasetAddRemoteView
      datastores={datastores}
      onAdded={handleDatasetAdded}
      defaultDatasetUrl={datasetUri}
    />
  ) : null;
}
